import { Modal } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import InfoWarningIcon from 'components/icons/InfoWarningIcon'
import React from 'react'
import { FlexWrapRole } from './style'

const CustomModal = ({ visible, onClose, message, onUpdate, isEligible }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      centered // This prop centers the modal vertically and horizontally
      footer={null} // Hide the default footer
      maskClosable={isEligible ?? false} // Prevent closing the modal when clicking outside
      closable={false} // Hide the close button
      bodyStyle={{
        borderRadius: '20px',
        padding: '32px 20px 32px 20px',
        textAlign: 'center',
      }}
    >
      {isEligible ? (
        <Flex column>
          <FlexWrapRole center>
            <InfoWarningIcon />
          </FlexWrapRole>
          <div
            style={{
              fontWeight: 700,
              lineHeight: '28px',
              fontSize: '20px',
              marginTop: ' 20px',
              color: '#010E30',
            }}
          >
            Please answer the questions carefully
          </div>
          <div
            style={{
              fontWeight: 400,
              lineHeight: '28px',
              fontSize: '15px',
              marginBottom: '20px',
              color: '#010E30',
            }}
          >
            Your responses will provide more opportunities for qualification
            based on your answers.
          </div>

          <FlexWrapRole gap="20px" center>
            <Button.Secondary text="Close" onClick={onClose} />
            <Button.IconButton
              text-align={'center'}
              text="Continue"
              onClick={onUpdate}
            />
          </FlexWrapRole>
        </Flex>
      ) : (
        <>
          {' '}
          <div
            style={{
              fontWeight: 700,
              lineHeight: '28px',
              fontSize: '20px',
              marginBottom: '20px',
              color: '#010E30',
            }}
          >
            {message}
          </div>
          <p
            style={{
              fontWeight: 500,
              lineHeight: '25px',
              fontSize: '16px',
              color: '#4D566E',
              marginBottom: '23px',
            }}
          >
            Please review for any mismatches in skills, location, or work
            experience.You may proceed with your application if the skills,
            location, and work experience are a match.
          </p>
          <FlexWrapRole gap="20px" center>
            <Button.Secondary text="Close" onClick={onClose} />
            <Button.Primary text={'Update Now'} onClick={onUpdate} />
          </FlexWrapRole>
        </>
      )}
    </Modal>
  )
}

export default CustomModal
